import React from 'react';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';

import AboutInfo from './AboutInfo/AboutInfo';

import cl from './About.module.css';

const About = (props) => {
  const position = props.aboutData.coordinates?.split(', ') || [
    48.865634, 2.417106,
  ];

  return (
    <section className={cl.app_about}>
      <AboutInfo
        shopStory={props.aboutData.story}
        shopStory2={props.aboutData.story2}
        shopStory3={props.aboutData.story3}
      />
      <div className={cl.contacts}>
        <div className={cl.contacts_divs}>
          <div>
            <h1>Contacts</h1>
            <p>
              Email:{' '}
              <a href={'mailto: soutien@' + props.aboutData.domain}>
                soutien@{props.aboutData.domain}
              </a>
            </p>
            <p>{props.aboutData.shopName} Groupe</p>
            <p>{props.aboutData.address}</p>
            <p>
              Tel: <a href="tel:+33149720600">+33 1 49 72 06 00</a>
            </p>
          </div>
          <MapContainer
            center={position}
            zoom={12}
            scrollWheelZoom={false}
            style={{ height: '450px', width: '700px', margin: '0 auto' }}
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker position={position} />
          </MapContainer>
        </div>
      </div>
    </section>
  );
};

export default About;
